import {
	AlertDialog,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	Button,
} from '@uturn/ui-kit';
import { useTranslation } from 'react-i18next';

type Props = {
	open: boolean;
	onCancel: () => void;
	onConfirm: () => void;
};

export const MultiUpdateUnsavedChangesDialog = ({
	open,
	onCancel,
	onConfirm,
}: Props) => {
	const { t } = useTranslation();

	return (
		<AlertDialog open={open}>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>
						{t(
							'pages.multi-update-unsaved-changes.dialog.confirmation.title',
							'Unsaved changes',
						)}
					</AlertDialogTitle>
					<AlertDialogDescription>
						{t(
							'pages.multi-update-unsaved-change.dialog.confirmation.description',
							'You have unsaved changes. Are you sure you want to close this dialog?',
						)}
					</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<AlertDialogCancel asChild>
						<Button variant="outline" onClick={onCancel}>
							{t(
								'pages.multi-update-unsaved-change.dialog.confirmation.cancel',
								'Keep editing',
							)}
						</Button>
					</AlertDialogCancel>
					<Button onClick={onConfirm}>
						{t(
							'pages.multi-update-unsaved-change.dialog.confirmation.confirm',
							'Discard',
						)}
					</Button>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	);
};
